export const GET_ASSOCIATED_TAGS_FOR_CONFIGURATION =
  "GET_ASSOCIATED_TAGS_FOR_CONFIGURATION";
export const GET_TAGS = "GET_TAGS";
export const CREATE_NEW_TAG = "CREATE_NEW_TAG";
export const DELETE_TAG = "DELETE_TAG";
export const EDIT_TAG = "EDIT_TAG";
export const CHANGE_TAGS_LIST = "CHANGE_TAGS_LIST";
export const UPDATE_TAGS_LIST_AND_LOADING = "UPDATE_TAGS_LIST_AND_LOADING";
